var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8333 15C27.8333 22.0877 22.0877 27.8333 15 27.8333C7.91234 27.8333 2.16666 22.0877 2.16666 15C2.16666 7.91234 7.91234 2.16666 15 2.16666C22.0877 2.16666 27.8333 7.91234 27.8333 15ZM30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM23.2763 8.27633C23.2763 9.13333 22.5816 9.82806 21.7246 9.82806C20.8676 9.82806 20.1729 9.13333 20.1729 8.27633C20.1729 7.41934 20.8676 6.72461 21.7246 6.72461C22.5816 6.72461 23.2763 7.41934 23.2763 8.27633ZM10.4879 16.2086C11.1556 18.7005 13.717 20.1793 16.2089 19.5116C18.7008 18.8439 20.1796 16.2825 19.5119 13.7906C18.8442 11.2987 16.2828 9.81989 13.7909 10.4876C11.299 11.1553 9.82015 13.7167 10.4879 16.2086ZM8.39503 16.7694C9.37244 20.4171 13.1219 22.5819 16.7696 21.6045C20.4174 20.627 22.5821 16.8776 21.6047 13.2298C20.6273 9.58209 16.8779 7.41735 13.2301 8.39476C9.58236 9.37218 7.41762 13.1216 8.39503 16.7694Z",
    fill: "url(#paint0_linear_1478_19845)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1478_19845",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapgram);
export default __webpack_public_path__ + "static/media/snapgram.e0c8804646c7a5298583db6a379a6611.svg";
export { ForwardRef as ReactComponent };